import { AppNotice } from 'components/appNotices/AppNotice';
import { AppNoticeAPI } from 'components/appNotices/types';
import { BlockWrapper } from 'utils/notice.styles';

export function AppNotices({
  appNotices,
  shouldUseCardStyles,
  shouldUseAnimation
}: {
  appNotices: AppNoticeAPI[];
  shouldUseCardStyles?: boolean;
  shouldUseAnimation?: boolean;
}): JSX.Element | null {
  if (!appNotices.length) {
    return null;
  }

  return (
    <BlockWrapper
      shouldUseCardStyles={shouldUseCardStyles}
      className={`animated ${shouldUseAnimation ? 'fadeInUp' : ''} fast`}
    >
      {appNotices.map((appNotice) => (
        <AppNotice key={appNotice.id} appNotice={appNotice} />
      ))}
    </BlockWrapper>
  );
}
